"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _GoogleBtn = _interopRequireDefault(require("./GoogleBtn"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _ProfileProvider = require("../../../../../provider/ProfileProvider");

var _Pc = require("@jobmatchme/amplify-tools/es/provider/Pc");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Rectangle = function Rectangle(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      customState = _ref.customState;

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      track = _useContext.track;

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
    container: true,
    spacing: 2,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GoogleBtn.default, {
        callback: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  track('funnelSignupSocial', {
                    provider: 'Google'
                  });
                  (0, _Pc.federatedSignInGoogle)(customState);
                  onClick();

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      })
    })
  });
};

var _default = /*#__PURE__*/_react.default.memo(Rectangle);

exports.default = _default;